import EventManager from "./EventManager";
import events from "./EventManager/events";
import analyticsInstance from "../analytics/analyticsInstance";

const addSpeakerToFavorites = speaker => analyticsInstance.addSpeakerToFavorites(speaker.name);
const addMusicToFavorites = track => analyticsInstance.addMusicToFavorites(track.title);
const addAlbumToFavorites = album => analyticsInstance.addAlbumToFavorites(album.title);
const removeSpeakerFromFavorites = speaker => analyticsInstance.removeSpeakerFromFavorites(speaker.name);
const removeMusicFromFavorites = track => analyticsInstance.removeMusicFromFavorites(track.title);
const removeAlbumFromFavorites = album => analyticsInstance.removeAlbumFromFavorites(album.title);

class FavoritesAnalyticsHandler {

  subscribe = () => {
    EventManager.getInstance().subscribe(events.ADD_SPEAKER_TO_FAVORITES, addSpeakerToFavorites);
    EventManager.getInstance().subscribe(events.ADD_TRACK_TO_FAVORITES, addMusicToFavorites);
    EventManager.getInstance().subscribe(events.ADD_ALBUM_TO_FAVORITES, addAlbumToFavorites);
    EventManager.getInstance().subscribe(events.REMOVE_SPEAKER_FROM_FAVORITES, removeSpeakerFromFavorites);
    EventManager.getInstance().subscribe(events.REMOVE_TRACK_FROM_FAVORITES, removeMusicFromFavorites);
    EventManager.getInstance().subscribe(events.REMOVE_ALBUM_FROM_FAVORITES, removeAlbumFromFavorites);
  };

  unsubscribe = () => {
    EventManager.getInstance().unsubscribe(events.ADD_SPEAKER_TO_FAVORITES, addSpeakerToFavorites);
    EventManager.getInstance().unsubscribe(events.ADD_TRACK_TO_FAVORITES, addMusicToFavorites);
    EventManager.getInstance().unsubscribe(events.ADD_ALBUM_TO_FAVORITES, addAlbumToFavorites);
    EventManager.getInstance().unsubscribe(events.REMOVE_SPEAKER_FROM_FAVORITES, removeSpeakerFromFavorites);
    EventManager.getInstance().unsubscribe(events.REMOVE_TRACK_FROM_FAVORITES, removeMusicFromFavorites);
    EventManager.getInstance().unsubscribe(events.REMOVE_ALBUM_FROM_FAVORITES, removeAlbumFromFavorites);
  };

  
}

export default FavoritesAnalyticsHandler;
